import { getPayments, Payment, addPayment, updatePayment } from '../api/payments';
import { updatePayments, updateSinglePayment } from './store/app-actions';
import { store } from '../store';

export const getPaymentsAndUpdateStore = async (page: number) => {
	page = page > 0 ? page : 1;

	const result = await getPayments(page, 10);

	store.dispatch(updatePayments(result.data, result.paginationPage, result.paginationCount));
};

export const addPaymentAndUpdateStore = async (payment: Payment) => {
	await addPayment(payment);
	await getPaymentsAndUpdateStore(store.getState().paymentPage);
};

export const updatePaymentAndUpdateStore = async (id: string, data: Payment) => {
	await updatePayment(id, data);
	await getPaymentsAndUpdateStore(store.getState().paymentPage);
};
